import React, { useState, createContext, useContext, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment';
import { getPersistentData, persistData } from '../utils/utilities'
// TODO: import settings from '../settings'

// builder dev
// const a360Credentials = {
//     client_id:'Gmvi05RLCArRTAq5NPS6SrqWBkuMxCwP',
//     client_secret:'OuWWLMGPG06cflH3',
//     redirect_uri: encodeURI("https://192.168.1.111:9009/a360callback.html")
//};

// dashboard dev
// const a360Credentials = {
//     client_id:'TJ7Lel8mBXnIxRAG6PlJ5Z9Kl0P9VDmy',
//     client_secret:'Qapi5llW1ABMIuAI',
//     redirect_uri: encodeURI("https://192.168.1.111:9339/a360callback.html")
// };


function A360Provider(props) {

    const { a360Credentials } = props;

    // const [ authorizationCode, setAuthorizationCode ] = useState('');
    // const [ a360token, setA360Token ] = useState({
    //     accessToken:'',
    //     refreshToken:'',
    //     tokenType:'',
    //     expiresIn:0
    // });
    // const [ accessToken, setAccesToken ] = useLocalStorage('Visuelse.A360.AccessToken', '');
    // const [ refreshToken, setRefreshToken ] = useLocalStorage('Visuelse.A360.RefreshToken', '');
    // const [ tokenType, setTokenType ] = useLocalStorage('Visuelse.A360.TokenType', '');
    // const [ expiresIn, setExpiresIn ] = useLocalStorage('Visuelse.A360.ExpiresIn', 0);


    // const a360Authorize = useCallback(async () => {
    //     const popupW = 480;
    //     const popupH = 640;
    //     const left = 64; //(window.screen.width - popupW) / 2;
    //     const top = 64; //(window.screen.height - popupH) / 2;
    //
    //     const windowRef = window.open(
    //         "https://developer.api.autodesk.com/authentication/v1/authorize" +
    //         "?response_type=code" +
    //         `&client_id=${a360Credentials.client_id}` +
    //         `&redirect_uri=${a360Credentials.redirect_uri}` +
    //         "&scope=data:read",
    //         "VisuElseSiteViewerManagerA360Authorize",
    //         `width=${popupW},height=${popupH},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,resizable,scrollbars`
    //     );
    //     if (windowRef) {
    //         // @ts-ignore
    //         window.onAuthWindowUnload = e => {
    //             console.log(e)
    //             if (!e.target || !e.target.URL) {
    //                 return;
    //             }
    //             if (e.target.URL.toLowerCase().indexOf('a360callback.html') === -1) {
    //                 return;
    //             }
    //             console.log(window.a360AuthCode)
    //             setAuthorizationCode(old => {
    //                 const code = window.a360AuthCode;
    //                 window.a360AuthCode = null;
    //                 return code;
    //             });
    //         };
    //     }
    //
    // }, [ setAuthorizationCode ]);
    //
    //
    // const a360RefreshToken = useCallback(() => {
    //
    //     const data = new URLSearchParams();
    //
    //     data.append("client_id", a360Credentials.client_id);
    //     data.append("client_secret", a360Credentials.client_secret);
    //     data.append("grant_type", 'refresh_token');
    //     data.append("refresh_token", a360token.refreshToken);
    //
    //     const ax = axios.create({
    //         withCredentials: false,
    //     });
    //
    //     ax
    //         .post(
    //             `https://developer.api.autodesk.com/authentication/v1/refreshtoken`,
    //             data,
    //             {
    //                 headers: {
    //                     'Content-Type': 'application/x-www-form-urlencoded'
    //                 }
    //             }
    //         )
    //         .then(resp => {
    //             console.log('refresh_token', resp)
    //
    //             // setTimeout(timerCB, 5 * 60 * 1000, {
    //             //     ...tok,
    //             //     accessToken: resp.data.access_token,
    //             //     refreshToken: resp.data.refresh_token,
    //             //     tokenType: resp.data.token_type,
    //             //     expiresIn: resp.data.expires_in,
    //             // });
    //
    //         })
    //         .catch(err2 => console.error('refresh_token', err2))
    //     ;
    // }, [ a360token ]);
    //
    //
    // const a360GetHubs = useCallback(async () => {
    //
    //     console.log(moment().format('HH:mm:ss.SSSSSS'))
    //     console.log(a360token)
    //     try {
    //         const ax = axios.create({
    //             withCredentials: false,
    //         });
    //
    //         const response = await ax.get(
    //             `https://developer.api.autodesk.com/userprofile/v1/users/@me`,
    //             { headers:{ 'Authorization':`${a360token.tokenType} ${a360token.accessToken}` } }
    //         );
    //
    //         console.log('zzz', response)
    //     }
    //     catch (e) {
    //         console.log('eee', e)
    //         console.log('eee', e.response)
    //         if (e.response && e.response.status === 401) {
    //             a360Authorize();
    //         }
    //     }
    //
    //
    //     // ax.get(`https://developer.api.autodesk.com/project/v1/hubs`, {
    //     //         headers: {
    //     //             'Authorization':`${tokenType} ${accessToken}`
    //     //         }
    //     //     })
    //     //     .then(resp => {
    //     //         console.log(JSON.stringify(resp.data));
    //     //     })
    //     //     .catch(err => console.error(err))
    //     // ;
    // }, [ a360token ]);
    //
    //
    // useEffect(() => {
    //     if (authorizationCode.length === 0)
    //         return;
    //     if (a360token.accessToken.length !== 0)
    //         return;
    //
    //     const data = new URLSearchParams();
    //
    //     data.append("client_id", a360Credentials.client_id);
    //     data.append("client_secret", a360Credentials.client_secret);
    //     data.append("grant_type", 'authorization_code');
    //     data.append("code", authorizationCode);
    //     data.append("redirect_uri", a360Credentials.redirect_uri);
    //
    //     const ax = axios.create({
    //         withCredentials: false,
    //     });
    //
    //     ax
    //         .post(`https://developer.api.autodesk.com/authentication/v1/gettoken`,
    //             data,
    //             { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    //         )
    //         .then(resp => {
    //             console.log(resp)
    //
    //             setA360Token(old => ({
    //                 ...old,
    //                 accessToken:resp.data.access_token,
    //                 refreshToken:resp.data.refresh_token,
    //                 tokenType:resp.data.token_type,
    //                 expiresIn:+resp.data.expires_in
    //             }));
    //         })
    //         .catch(err => console.log('err', err));
    //
    // }, [ authorizationCode, setA360Token ]);


    // const getPersistentData = (key, initialValue = '') => {
    //     try {
    //         const item = window.localStorage.getItem(key);
    //         return item ? JSON.parse(item) : initialValue;
    //     } catch (error) {
    //         return initialValue;
    //     }
    // }
    //
    //
    // const persistData = (key, value) => {
    //     try {
    //         window.localStorage.setItem(key, JSON.stringify(value));
    //     } catch (error) {
    //     }
    // };



    const a360call = ({ url, method }) => {

        let accessToken = getPersistentData('Visuelse.A360.AccessToken');
        let refreshToken = getPersistentData('Visuelse.A360.RefreshToken');
        let tokenType = getPersistentData('Visuelse.A360.TokenType');
        let expiresIn = getPersistentData('Visuelse.A360.ExpiresIn', 0);
        let expiresAt = getPersistentData('Visuelse.A360.ExpiresAt', 0);

        const persistAuth = (access, refresh, type, expire) => {
            accessToken = access;
            refreshToken = refresh;
            tokenType = type;
            expiresIn = expire;
            const expiresAt = moment().add(expiresIn, 'seconds').toDate().getTime();

            persistData('Visuelse.A360.AccessToken', accessToken);
            persistData('Visuelse.A360.RefreshToken', refreshToken);
            persistData('Visuelse.A360.TokenType', tokenType);
            persistData('Visuelse.A360.ExpiresIn', expiresIn);
            persistData('Visuelse.A360.ExpiresAt', expiresAt);
            console.log('A360', 'expires at', moment(expiresAt).format('YYYY-MM-DD HH:mm:ss'));
        }


        const handleTokenResult = (response) => {
            persistAuth(
                response.data.access_token,
                response.data.refresh_token,
                response.data.token_type,
                response.data.expires_in
            );
        }


        const axiosRequestInterceptor = (request) => {
            console.log('A360', request)
            return request;
        }

        const axiosRequestInterceptorError = (error) => {
            console.error('A360', error)
            return Promise.reject(error);
        }

        const axiosResponseInterceptor = (response) => {
            console.log('A360', response)
            return response;
        }

        const axiosResponseInterceptorError = (error) => {
            console.error('A360', error)
            return Promise.reject(error);
        }


        const callGetToken = (code) => {
            console.log('A360', 'get authorization_code')
            const rtax = axios.create();
            rtax.interceptors.request.use(axiosRequestInterceptor, axiosRequestInterceptorError);
            rtax.interceptors.response.use(axiosResponseInterceptor, axiosResponseInterceptorError);

            const data = new URLSearchParams();

            data.append("client_id", a360Credentials.client_id);
            data.append("client_secret", a360Credentials.client_secret);
            data.append("grant_type", 'authorization_code');
            data.append("code", code);
            data.append("redirect_uri", a360Credentials.redirect_uri);

            return rtax.request({
                url:`https://developer.api.autodesk.com/authentication/v1/gettoken`,
                method: 'POST',
                data,
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            ;
        }


        const callRefreshToken = () => {
            console.log('A360', 'refresh token')
            const rtax = axios.create();
            rtax.interceptors.request.use(axiosRequestInterceptor, axiosRequestInterceptorError);
            rtax.interceptors.response.use(axiosResponseInterceptor, axiosResponseInterceptorError);

            const data = new URLSearchParams();

            data.append("client_id", a360Credentials.client_id);
            data.append("client_secret", a360Credentials.client_secret);
            data.append("grant_type", 'refresh_token');
            data.append("refresh_token", refreshToken);

            return rtax.request({
                url:`https://developer.api.autodesk.com/authentication/v1/refreshtoken`,
                method: 'POST',
                data,
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            ;
        }


        const callAuthorize = () => new Promise((resolve, reject) => {

            console.log('A360', 'authorize')
            
            const popupW = 480;
            const popupH = 640;
            const left = 64; //(window.screen.width - popupW) / 2;
            const top = 64; //(window.screen.height - popupH) / 2;

            window.a360AuthCode = '';

            const windowRef = window.open(
                "https://developer.api.autodesk.com/authentication/v1/authorize" +
                "?response_type=code" +
                `&client_id=${a360Credentials.client_id}` +
                `&redirect_uri=${a360Credentials.redirect_uri}` +
                "&scope=data:read",
                "VisuElseSiteViewerManagerA360Authorize",
                `width=${popupW},height=${popupH},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,resizable,scrollbars`
            );
            if (windowRef) {

                const timerFunction = () => {
                    if (!windowRef.closed) {
                        setTimeout(timerFunction, 200);
                        return;
                    }

                    const code = window.a360AuthCode || '';
                    window.a360AuthCode = '';
                    if (code.length > 0) {
                        resolve(code);
                    }
                    else {
                        reject(new Error('a360 reject auth'));
                    }
                }

                setTimeout(timerFunction, 200);

                // @ts-ignore
                window.onAuthWindowUnload = e => {
                    console.log('A360', 'authunload', e)
                    if (!e.target || !e.target.URL) {
                        reject(new Error('unload1'));
                        return;
                    }
                    if (e.target.URL.toLowerCase().indexOf('a360callback.html') === -1) {
                        reject(new Error('unload2'));
                        return;
                    }

                    // const code = window.a360AuthCode;
                    // window.a360AuthCode = '';
                    //
                    // resolve(code);
                };
            }
            else {
                reject(new Error('a360 no window'));
            }
        });


        return new Promise((resolve, reject) => {

            const doRequest = () => {
                console.log('A360', 'request')
                
                const rtax = axios.create();
                rtax.interceptors.request.use(axiosRequestInterceptor, axiosRequestInterceptorError);
                rtax.interceptors.response.use(axiosResponseInterceptor, axiosResponseInterceptorError);

                return rtax
                    .request({
                        url,
                        method,
                        headers:{
                            'Authorization':`${tokenType} ${accessToken}`
                        }
                    })
                    .then(response => {
                        resolve(response)
                    })
            };

            doRequest()
            .catch(err => {
                if (err.response && err.response.status !== 401) {
                    reject(err);
                }

                callRefreshToken()
                .then(rtresponse => {
                    handleTokenResult(rtresponse);

                    doRequest().catch(err => reject(err));
                })
                .catch(rterr => {
                    if (rterr.response && rterr.response.status !== 400) {
                        reject(rterr);
                    }
                    else {
                        callAuthorize()
                            .then(code => {
                                if ((code || '').length === 0) {
                                    reject(new Error("no auth code"));
                                }
                                else {
                                    callGetToken(code)
                                        .then(tkresponse => {
                                            handleTokenResult(tkresponse);

                                            doRequest().catch(err => reject(err));
                                        })
                                        .catch(tkerr => reject(tkerr))
                                }
                            })
                            .catch(err => reject(err))
                    }
                })
            })
        })
    }


    const a360GetUserInfo = () => {
        return a360call({
            url:`https://developer.api.autodesk.com/userprofile/v1/users/@me`,
            method: 'GET',
        });
    }

    const a360GetTokenInfo = () => {
        return a360call({
            url:`https://developer.api.autodesk.com/userprofile/v1/users/@me`,
            method: 'GET',
        })
        .then(response => {
            return {
                accessToken : getPersistentData('Visuelse.A360.AccessToken'),
                refreshToken : getPersistentData('Visuelse.A360.RefreshToken'),
                tokenType : getPersistentData('Visuelse.A360.TokenType'),
                expiresIn : getPersistentData('Visuelse.A360.ExpiresIn', 0),
            }
        })
        ;
    }

    const a360GetHubs = () => {
        return a360call({
            url:`https://developer.api.autodesk.com/project/v1/hubs`,
            method: 'GET',
        });
    }

    const a360GetProjects = (hub) => {
        return a360call({
            url:`https://developer.api.autodesk.com/project/v1/hubs/${hub}/projects`,
            method: 'GET',
        });
    }

    const a360GetProjectTopFolders = (hub, project) => {
        return a360call({
            url:`https://developer.api.autodesk.com/project/v1/hubs/${hub}/projects/${project}/topFolders`,
            method: 'GET',
        });
    }


    const a360GetProjectFolderContents = (project, folder) => {
        return a360call({
            url:`https://developer.api.autodesk.com/data/v1/projects/${project}/folders/${folder}/contents`,
            method: 'GET',
        });
    }


    const a360GetProjectItem = (project, item) => {
        return a360call({
            url:`https://developer.api.autodesk.com/data/v1/projects/${project}/items/${item}`,
            method: 'GET',
        });
    }


    return (
        <A360Context.Provider value={{
            a360GetUserInfo,
            a360GetTokenInfo,
            a360GetHubs,
            a360GetProjects,
            a360GetProjectTopFolders,
            a360GetProjectFolderContents,
            a360GetProjectItem
        }} {...props} />
    );
}


const A360Context = createContext({
    a360GetUserInfo:null,
    a360GetTokenInfo:null,
    a360GetHubs:null,
    a360GetProjects:null,
    a360GetProjectTopFolders:null,
    a360GetProjectFolderContents:null,
    a360GetProjectItem:null,
});


const useA360 = () => useContext(A360Context);


A360Provider.propTypes = {
    a360Credentials:PropTypes.object.isRequired,
}


export { A360Provider, useA360 }
